export default __webpack_public_path__ + "static/media/HPS.2d686c4d.png";